import { render, staticRenderFns } from "./configFieldsModal.vue?vue&type=template&id=54161ac0"
import script from "./configFieldsModal.vue?vue&type=script&lang=js"
export * from "./configFieldsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports